var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7487 5.43332C10.8966 5.58423 10.8966 5.82576 10.7487 5.97668L4.49401 12.2564C4.34396 12.4078 4.16433 12.5267 3.96632 12.6057L0.598416 13.9718C0.454243 14.0299 0.289349 13.9963 0.179368 13.8864C0.0187871 13.784 -0.0436852 13.5801 0.0319249 13.4052L1.36667 10.0364C1.4456 9.83828 1.56447 9.65861 1.71588 9.50852L7.97831 3.24436C8.05117 3.17088 8.15034 3.12955 8.2538 3.12955C8.35726 3.12955 8.45643 3.17088 8.52929 3.24436L10.7487 5.43332ZM13.659 0.85394L13.1469 0.34163C12.9288 0.123211 12.6329 0.000361071 12.3243 8.93106e-05H11.7345C11.4205 -0.0037982 11.1183 0.119369 10.8964 0.34163L9.49183 1.76213C9.34394 1.91304 9.34394 2.15457 9.49183 2.30549L11.6724 4.51773C11.7453 4.59121 11.8445 4.63254 11.9479 4.63254C12.0514 4.63254 12.1505 4.59121 12.2234 4.51773L13.659 3.105C13.8812 2.88306 14.0044 2.58074 14.0005 2.26667V1.67674C14.0002 1.36804 13.8774 1.07209 13.659 0.85394Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.2e9b85b912a227506ed661e9f2dc638e.svg";
export { ForwardRef as ReactComponent };